import { t as Swiper } from "./swiper.esm-Dvfjl6Fb.js";
import { t as Navigation } from "./navigation-BSfLh-wX.js";
//#region src/scripts/extenders/trustpilot-reviews.js
var trustpilotReviews = class extends HTMLElement {
	constructor() {
		super();
		const swiperHolder = this.querySelector(".swiper");
		const swiperWrapper = this.querySelector(".swiper-wrapper");
		const changedReviews = this.querySelector("#reviewsString").innerHTML.replaceAll("\\'", "\"").replaceAll("\"s", "'s").replaceAll(",'s", ",\"s").replaceAll(":'s", ":\"s").replaceAll(/(\r\n|\n|\r)/gm, "");
		const handleTrustpilotReviews = (reviews) => {
			const star = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.99951 10.4792L10.0412 9.70833L11.312 13.625L6.99951 10.4792ZM13.9995 5.41667H8.64535L6.99951 0.375L5.35368 5.41667H-0.000488281L4.33285 8.54167L2.68701 13.5833L7.02034 10.4583L9.68701 8.54167L13.9995 5.41667Z" fill="white"/>
      </svg>
      `;
			reviews.reviews.forEach((review) => {
				const date = new Date(review.createdAt);
				const reviewTemplate = `
          <a class="review swiper-slide" href="https://www.trustpilot.com/reviews/${review.id}" target="_blank">
            <div class="review__quotes">
              <svg width="34" height="30" viewBox="0 0 34 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 0C6.75 0 0 6.75 0 15V30H15V15H5C5 9.45 9.45 5 15 5V0ZM34 0C25.75 0 19 6.75 19 15V30H34V15H24C24 9.45 28.45 5 34 5V0Z" fill="#219653"/>
              </svg>            
            </div>
            <div class="review__title">
              <p>${review.title}</p>
            </div>
            <div class="review__stars">
              ${[...Array(review.stars)].map(() => star).join("")}
              <p>${date.getDate()} / ${date.getMonth() + 1} / ${date.getFullYear()}</p>
            </div>
            <div class="review__content">
              <p>${review.text}</p>
            </div>
            <div class="review__author">
              <p>${review.consumer.displayName}</p>
            </div>
          </a>
        `;
				swiperWrapper.insertAdjacentHTML("beforeend", reviewTemplate);
			});
		};
		handleTrustpilotReviews(JSON.parse(changedReviews));
		new Swiper(swiperHolder, {
			modules: [Navigation],
			slidesPerView: "auto",
			spaceBetween: 32,
			loop: true,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev"
			}
		});
	}
};
if (customElements.get("trustpilot-reviews") === void 0) customElements.define("trustpilot-reviews", trustpilotReviews);
//#endregion
